import { apiGateway } from "../api";

async function getIRYears() {
    try {
        const response = await apiGateway.get('/financeiro/impostorenda/pf/anos/buscar');

        return response.data.anos;
    } catch (error) {
        return error;
    }
}

async function generatePDFFile(body) {
    try {
        const response = await apiGateway.post('/financeiro/impostorenda/pf/recuperar/gerar-pdf', body, {
            responseType: 'blob'
        });

        return response.data;
    } catch (error) {
        return error;
    }
}

async function generateXMLFile(body) {
    try {
        const response = await apiGateway.post('/financeiro/impostorenda/pf/recuperar/gerar-xml', body);

        return response;
    } catch (error) {
        return error;
    }
}

export { getIRYears, generatePDFFile, generateXMLFile };
